import { MdEdit } from 'react-icons/md';
import { Box, IconButton } from '@mui/material';
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-pro';

const noValue = <span>&nbsp;</span>;

export const DataGridEditableCellRender = (params: React.PropsWithChildren<GridRenderCellParams>) => {
  const apiRef = useGridApiContext();
  const { field, id, value } = params;
  const handleClickEdit = () => {
    apiRef.current.setCellMode(id, field, 'edit');
  };

  return (
    <Box
      className='showCellEditableContainer'
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      width='100%'
      minWidth={0}
    >
      <Box className='MuiDataGrid-cellContent'>{params.children ? params.children : value || noValue}</Box>
      <IconButton
        onClick={handleClickEdit}
        className='showCellEditableIcon'
        title='Click icon or double-click cell to edit'
        sx={{
          flexShrink: 0,
          visibility: 'hidden',
        }}
      >
        <MdEdit />
      </IconButton>
    </Box>
  );
};
